(ns web3.screens.root-public
  (:require [web3.view :as v]
            [web3.hints.core :as hint]
            [web3.constants :as constants]
            [web3.modals.forms :as forms]
            [web3.modals.screens :as modal]
            [web3.ui-state :as ui-state]
            [web3.modals.alerts :as alerts]
            [re-frame-simple.db :as db]
            [web3.components.drawer :as drawer]
            [web3.routing.core :as routing]
            [shadow.lazy :as lazy]))

(def intercom-badge  (lazy/loadable web3.components.intercom/badge))

(v/defview modal-views
  [{:keys [modal/closable?]
    :or {closable? true}}]
  (let [form-modal? (db/get-in [:db/routers :router/form-modal])]
    [:div#modals
     [drawer/temporary-drawer
      (let [frames (routing/breadcrumbs :router/drawer)]
        {:on-back (fn [n]
                    (db/dispatch [:routing/nav (routing/drop-segments (or n 1) :router/drawer)]))
         :frames frames
         :active? (and (seq frames)
                       (not form-modal?))})]

     [alerts/alert-frames
      {:z-index (:alert-modal constants/z-index)
       :modal/closable? closable?}]

     (when-not (and (ui-state/mobile?)
                    form-modal?)
       [modal/router-frames
        {:router :router/content-modal
         :modal-view modal/lightbox-slider
         :modal/closable? closable?
         :z-index (:router/content-modal constants/z-index)}])

     [modal/router-frames
      {:router :router/form-modal
       :modal/closable? closable?
       :modal-view forms/breadcrumb-slider
       :z-index (:router/form-modal constants/z-index)}]]))

(v/defview root [{root-router :router/root}]
  (let [{:keys [view route-params]} root-router]
    [:div
     [modal-views {:modal/closable? false}]
     [:div.relative {:style {:z-index (:root/main constants/z-index)}}
      [view route-params]]

     [hint/render-hints]

     (when (lazy/ready? intercom-badge)
       [@intercom-badge])]))